import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleGuarantorUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <path
          d="M28 29c2.94 0 4.56.4 5.69.8 2.8.98 5.81 3 5.81 7.44 0 1.12-.8 1.96-2.21 2.42-1.65.54-5.76.7-8.94.7h-.7c-3.18 0-7.29-.16-8.94-.7-1.4-.46-2.21-1.3-2.21-2.42 0-4.44 3.01-6.46 5.81-7.44a15.9 15.9 0 015.33-.8H28zm0-14.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
          fill="#FFF"
        />
        <circle fill="#CCC" cx={38} cy={36} r={8} />
        <path
          d="M37.67 39.85a10.74 10.74 0 01-2.69-2c-.67-.74-1-2.2-.98-4.34 1.68 0 3.01-.44 4-1.31.99.87 2.32 1.3 4 1.3.02 2.16-.3 3.6-.98 4.35A11.3 11.3 0 0138 40.03z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgPicCircleGuarantorUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleGuarantorUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleGuarantorUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
